import PropTypes from "prop-types";
import React from "react";
import envconfig from "../../../envconfig";
import Select from "./index";
import { debounce } from "lodash";

class LazySelect extends React.Component {
    static defaultProps = {
        placeholder: "Select",
    };
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || (props.multiple ? [] : null),
            loading: props.loading,
        };
        this.onInput = debounce(this.onInput.bind(this), 300);
        this.onChange = this.onChange.bind(this);
    }

    onInput(e, a) {
        if (a && a.action.match(/input-blur|menu-close/)) return;

        this.setState({
            loading: false,
        });

        if (e.target.value.length > envconfig.MAX_CHARACTERS_SEARCH_INPUT) {
            this.props.onLoad(e.target.value);
        } else {
            if (e.target.value !== "")
                this.setState({
                    loading: true,
                });
        }
    }

    onChange(value) {
        this.props.onChange(value);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading !== this.props.loading && this.props.loading !== prevState.loading) {
            this.setState({ loading: this.props.loading });
        }
    }

    render() {
        const { loading } = this.state;
        const { data, value, placeholder, multiple, disabled, ...props } = this.props;
        return (
            <Select
                placeholder={placeholder}
                value={value}
                multiple={multiple}
                onChange={this.onChange}
                onInput={(e, a) => this.onInput({ target: { value: e } }, a)}
                options={data}
                loading={loading}
                disabled={disabled}
                {...props}
            />
        );
    }
}

LazySelect.propTypes = {
    data: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default LazySelect;
